module.exports = __webpack_public_path__ + "static/media/DocumentSync-Logo.860d70f0.png";